<template>
    <div class="list-agent-card">
        <a class="avatar-box-a" :href="redirectUrl"
           :target="detailUrlTarget"
           role="img"
           rel="noopener noreferrer">
            <AgentHeadShot :headshots="agent.headShots" :initImage="agent.image" :keyClass="`md-team-agent-card-simple-${theme}`" :useParentDom="true"></AgentHeadShot>

            <div class="site-img-info">
                <p
                    class="info-item b-info agent-phone"
                    v-if="!!agent.phone"
                >
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >
                        {{ $ft.formatPhone(agent.phone) }}
                    </a>
                </p>
                <p
                    class="info-item b-info agent-email"
                    v-if="!!agent.email"
                >
                    <a
                        :href="'mailto:' + agent.email"
                        target="_top"
                        rel="noopener noreferrer"
                    >
                        {{ agent.email }}
                    </a>
                </p>
            </div>
        </a>
        <div class="agent-info">
            <div v-if="theme === 'layout5'">
                <a v-if="agent.fullName" class="agent-name" :href="redirectUrl">{{ agent.fullName }}</a>
                <p v-if="agent.position" class="agent-position">{{ agent.position }}</p>
            </div>
            <div v-if="theme === 'layout7'">
                <a v-if="agent.fullName" class="agent-name" :href="redirectUrl">{{ agent.fullName }}</a>
                <p v-if="agent.position" class="agent-position">
                    <span>{{ agent.position }}</span>
                    <span v-if="agent.license" class="license"
                    >{{ licenseName }}{{ agent.license }}</span
                    > 
                </p>
                <BookAppointment
                    v-if="showCalendarLink"
                    :agent="agent"
                    :variant="bookAppointmentProps?.variant"
                    :btnColor="bookAppointmentProps?.btnColor"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import agentInfo from "../agent-info";
import BookAppointment from './book-appointment.vue';
import AgentHeadShot from "@/components/agent-headshot.vue"

export default {
    components: {
        BookAppointment,
        AgentHeadShot
    },
    props: {
        theme: {
            type: String,
            default: '',
        },
        agent: {
            type: Object,
            required: true
        },
        detailUrlTarget: {
            type: String,
        },
        bookAppointmentProps: {
            type: Object,
            default: {
                variant: 'button'
            }
        },
        showCalendarLink: {
            type: Boolean,
            default: false
        },
    },
    mixins: [agentInfo],
    computed: {
        ...mapState(usePageStore, {
            page: store => store.page
        }),
        licenseName({ page }) {
            return page.licenseName;
        },
    }

};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.list-agent-card{
    .avatar-box-a{
        color: #fff;
        font-size: 18px;
        line-height: 18px;
        position: relative;
        overflow:hidden;
        @include media-600 {
            font-size: 14px;
        }
        .site-img-info{
            display: none;
            position: absolute;
            bottom: 0px;
            width: 100%;
            text-align: center;
            padding: 85px 0px 30px;
            background: linear-gradient(180deg, rgba(25, 25, 25, 0) 10%, rgba(25, 25, 25, 0.9) 100%);
            @include media-600 {
               display: block;
               padding-bottom: 20px;
            }
        }
        .agent-image{
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
        }
        
        &:hover{
            .site-img-info{
                display: block;
            }
            img {
                transform: scale(1.1);
            }
        } 
        .info-item {
            & + .info-item {
                margin-top: 10px;
            }
        }
    }
}


</style>
